// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"25ffd17c","312":"7feccaba","633":"78e7bb8e"}[chunkId] + ".chunk.css";
};